import React from 'react';
import '../styles/theme.css';
import '../styles/SignUp.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SignUpEnrollmentPanel from '../components/SignUpEnrollmentPanel';
import SignUpIdentityContext from '../components/SignUpIdentityContext';
/* IMPORTS */

function SignUpPage() {
  return (
    <div className="si-root">
      <div id="signupnavbarslot" className="si-slot-signupnavbarslot">
        <Navbar activePage={"Sign Up"} />
      </div>
      <div id="signupenrollmentpanel" className="si-slot-signupenrollmentpanel">
        <SignUpEnrollmentPanel />
      </div>
      <div id="signupidentitycontext" className="si-slot-signupidentitycontext">
        <SignUpIdentityContext />
      </div>
      <div id="signupfooterslot" className="si-slot-signupfooterslot">
        <Footer />
      </div>
    </div>
  );
}

export default SignUpPage;